import React from 'react';
import { useQueryClient } from 'react-query';
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import _ from "underscore";

import { useFuelMarkets } from "../../../services/fuel";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  }
});

const FuelMarketLookup = props => {

  const queryClient = useQueryClient();
  const extraKeys = [];
  const records = useFuelMarkets({queryClient, useCache: true, extraKeys});

  const handleChange = (event, record) => {    
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = { value: record.fuelMarketCode, found: false, data: {}}
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.fuelMarketCode);
      }
    }
  }
  const handleInputChange = (event, value) => {    
    if (!event || (event.type !== 'change' && !(event.type === 'blur' && value))) return;
    if (props.returnType === "object") {
      const returnObject = { value, found: false, data: {} }
      const record = _.findWhere(records, { fuelMarketCode: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(value);
    }
  }

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  return (
    <Autocomplete
      id="fuelMarket-lookup"
      disableClearable={true}
      autoSelect={true}
      autoHighlight={true}
      inputValue={props.value}
      options={props.allowEmpty
        ?[
          ...(records.data||[]), 
          {
            fuelMarketUuid: "",
            fuelMarketCode: "",
            fuelMarketName: "",
            fuelMarketType: "NONE",
          }
        ]
        :records.data||[]
      }
      filterOptions={props.filterOptions}
      PopperComponent={DropdownList}
      getOptionSelected={(option, value) => option.fuelMarketCode === value.fuelMarketCode}
      getOptionLabel={(option) => option.fuelMarketCode}
      onChange={handleChange}
      onInputChange={handleInputChange}
      renderOption={(option) => {
        if (option.fuelMarketCode) {
          return (
            <React.Fragment>
              {option.fuelMarketCode} - {option.fuelMarketName}
            </React.Fragment>
          )  
        }
        return (
          <React.Fragment>&nbsp;</React.Fragment>
        )
      }}
      style={{
        width: (props.width||"100%"),
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          placeholder={props.placeHolder}
          inputProps={{
            ...params.inputProps,
          }}
        />
      )}
    />
  )

}

export default withStyles(styles) (FuelMarketLookup);
